import { makeObservable, observable } from 'mobx';
import { ElementInstance } from '../model';

export type ElementViewOptions = {
  openMenus: boolean;
  tabIndex: number;
};

class MutableElementViewOptions {
  openMenus = false;
  tabIndex = 0;

  constructor() {
    makeObservable(this, {
      openMenus: observable.ref,
      tabIndex: observable.ref,
    });
  }
}

export const DEFAULT_ELEMENT_VIEW_OPTIONS = Object.freeze({
  openMenus: false,
  tabIndex: 0,
});

class ElementViewOptionsStore {
  private readonly forElement = new WeakMap<
    ElementInstance,
    MutableElementViewOptions
  >();

  get(el: ElementInstance) {
    if (!this.forElement.has(el)) {
      this.forElement.set(el, new MutableElementViewOptions());
    }
    return this.forElement.get(el)!;
  }
}

export const globalElementViewOptions = new ElementViewOptionsStore();
